import { t } from "i18next";
import { useProductSetsList } from "modules/productSets";
import { Modal, SearchInput } from "ui";

import { ProductSetSelectorModalProps } from "../ProductsFieldForForms.types";
import { ProductSetSelectorTable } from "./ProductSetSelectorTable";

import styles from "../ProductsFieldForForms.module.scss";

const ProductSetSelectorModal = ({
  isOpen,
  onClose,
  selectedProductSet,
  onChangeSelectedProductSet
}: ProductSetSelectorModalProps) => {
  const {
    productSets,
    searchValue,
    sorting,
    setSorting,
    setSearchValue,
    isLoading
  } = useProductSetsList();

  return (
    <Modal
      title={t("Select Product set")}
      isOpen={isOpen}
      onClose={onClose}
      contentClassName={styles.productSetSelectorModal}
      footer={<></>}
    >
      <>
        <SearchInput value={searchValue} onChange={setSearchValue} />

        <ProductSetSelectorTable
          productSets={productSets}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          selectedProductSet={selectedProductSet}
          onChangeSelectedProductSet={onChangeSelectedProductSet}
        />
      </>
    </Modal>
  );
};

export default ProductSetSelectorModal;
